import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VALIDATE_GOOGLE_TOKEN, REFRESH_GOOGLE_TOKEN, PROJECT_API_KEY } from '../util/api.endpoints';
import { Injectable } from '@angular/core';

/**
 * Service response for fetch, create, update and delete the Job.
 */
@Injectable({
    providedIn: 'root'
})
export class GoogleIntegrationService {
    constructor(private http: HttpClient) { }

    validateToken(obj: any) {
        const url = VALIDATE_GOOGLE_TOKEN;

        const headers = new HttpHeaders({
            'x-api-key': PROJECT_API_KEY,
            'Content-Type': 'application/json'
        });

        return this.http.post<any>(url, obj, { headers });
    }

    generateRefreshToken(obj: any) {
        const url = REFRESH_GOOGLE_TOKEN;

        const headers = new HttpHeaders({
            'x-api-key': PROJECT_API_KEY,
            'Content-Type': 'application/json'
        });

        return this.http.post<any>(url, obj, { headers });
    }
}